

import {Component, Prop, Vue} from "vue-property-decorator"
import {Verslagen} from "@/types/Verslagen";

@Component({})
export default class JaarverslagenList extends Vue {
  name!: "jaarverslagenListFR"

  @Prop()
  verslagen!: Array<Verslagen>;

  @Prop()
  jaarverslagenlink!: string;

}
